
export function formatCurrency(x,digits=2) {
    let curr=parseFloat(x).toFixed(digits).toLocaleString('en')  //
    return "$"+curr;
}
export function formatPct(x,digits=0) {
    let pct=parseFloat(x).toFixed(digits)
    pct = (pct<1.0 && pct>-1.0) ? 0.0 : pct
    return pct+"%";
}
export function formatTimestamp(seconds) {
    var d = new Date(null);
    d.setSeconds(seconds);
    return d.toISOString().substr(11, 8);
}
export function validateNumericInput(val,allowZero=false,allowNeg=false) {
    val=val.toString()
    return (val.trim()!=="" && (allowZero || parseFloat(val)!==0.0) && ( allowNeg || (parseFloat(val)>=0)) )
}
export function validateStringInput(val,allowEmpty=false) {
    return ( (allowEmpty) || val.trim()!=="" );
}


export function descendingComparator(a, b, sort_column) {
    if (b[sort_column] < a[sort_column]) {
      return -1;
    }
    if (b[sort_column] > a[sort_column]) {
      return 1;
    }
    return 0;
  }
  
  export function getComparator(sort_order, sort_column) {
    return sort_order === 'desc'
      ? (a, b) => descendingComparator(a, b, sort_column)
      : (a, b) => -descendingComparator(a, b, sort_column);
  }

  export function stableSort(array, sort_order, sort_column) {
    const comparator=getComparator(sort_order, sort_column);
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  